import { toast } from 'react-toastify';

import { SessionInfo, SpanText, ButtonTrash } from './styles';
import { Session } from '../../../types/session';
import { useAuth } from '../../../hooks/useAuth';
import { Categories, Actions } from '../../../types/gtm';
import { formatLocation } from '../../../util/location';
import { deleteSession } from '../../../services/session';

export interface Props {
  session: Session;
  isBetaUser: boolean;
  removeSessionState: (ids: string[]) => void;
}

export default function SessionInfoContainer({
  session,
  isBetaUser,
  removeSessionState,
}: Props): JSX.Element {
  const { authenticateOnAPI, user } = useAuth();

  async function removeSession(userSession: Session) {
    const sessionIds = await deleteSession(
      userSession,
      authenticateOnAPI,
      isBetaUser,
    );

    if (sessionIds && sessionIds.length > 0) {
      const dateWithoutTime = session.date.substring(0, 10);

      window.dataLayer.push({
        event: 'customEventUserInteraction',
        event_category: Categories.Home,
        event_action: Actions.ClickDisconnectSession,
        event_label: `Ultima conexao ${dateWithoutTime}`,
        bd_suser_code: user?.globoId,
      });

      removeSessionState(sessionIds);
      toast.success('Dispositivo desconectado com sucesso!');
      return;
    }
    toast.error('Não foi possível deletar a sessão do usuário.');
  }

  return (
    <SessionInfo>
      <div>
        <b> {session.deviceName} </b>
        {session.isActive ? (
          <SpanText>Sessão atual </SpanText>
        ) : (
          <ButtonTrash
            aria-label="Desconectar sessão deste dispositivo"
            onClick={() => {
              removeSession(session);
            }}
          >
            Sair
          </ButtonTrash>
        )}
        <br />
        {session.date} <br />
        {formatLocation(session.location)} <br />
      </div>
    </SessionInfo>
  );
}
